/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated.js';
import { UnitDependencies } from './dependenciesUnitClass.generated.js';
import { createAvogadro } from '../../factoriesAny.js';
export var avogadroDependencies = {
  BigNumberDependencies,
  UnitDependencies,
  createAvogadro
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesAvogadro.generated.js
// module id = BUKV
// module chunks = 3